import type { PermissionsTree } from "@/adapters/api";
import { useMe } from "@/hooks/use-me.ts";

export type PermissionKey = string;
export type PermissionInput = PermissionKey | PermissionKey[];

export function hasPermission(
	tree: PermissionsTree | undefined,
	key: PermissionKey,
): boolean {
	if (!key) return true;
	let node: unknown = tree;
	for (const part of key.split(":")) {
		if (!node || typeof node !== "object") return false;
		node = (node as Record<string, unknown>)[part];
		if (node === undefined) return false;
	}
	return node === true || (typeof node === "object" && node !== null);
}

export function usePermissions() {
	const me = useMe();
	const isAdmin = !!me.data?.account?.admin;

	function has(input: PermissionInput): boolean {
		if (isAdmin) return true;
		if (Array.isArray(input)) {
			return input.some((key) => hasPermission(me.data?.permissions, key));
		}
		return hasPermission(me.data?.permissions, input);
	}

	return { has, isAdmin, isLoading: me.isLoading };
}
